import { Component, Input, Output, EventEmitter, forwardRef, OnChanges, SimpleChanges, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';


/**
   * Logger Factory
   * @namespace value: value of radio
   * @namespace disabled: if true the radio is disabled
   * <ute-radio  value="value" disabled="true"></ute-radio>
*/

@Component({
  selector: 'ute-radio',
  templateUrl: 'ute-radio.component.html',
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(()=> UteRadioComponent),
    multi: true
  }]
})
export class UteRadioComponent implements OnChanges, OnInit{
  @Input() value: string;
  @Input() initialValue: string;
  @Input() disabled: boolean;

  @Output() change: EventEmitter<any> = new EventEmitter<any>();
  @Output() blur: EventEmitter<any> = new EventEmitter<any>();

  public valueRadio: string = '';
  public innerValue: any[];
  private propagateTouch = () => { };

  constructor() {}

  ngOnInit(){}

  onBlur(event) {
    this.propagateTouch();
    this.blur.emit(event);
  }
  public writeValue(obj: any) {
    if(obj) {
      this.valueRadio = obj;
    } 
  }
  public registerOnChange(fn: any) {}

  public registerOnTouched(fn: any) {
    this.propagateTouch = fn;
  }

  ngOnChanges(change: SimpleChanges){
    if(change && change.initialValue){
      this.initialValue = change.initialValue.currentValue;
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/components/atoms/ute-radio/ute-radio.component.ts